export default __webpack_public_path__ + "static/media/arrow-right.52be2438.svg";